import { render, staticRenderFns } from "./GotoLeaveVoucher.vue?vue&type=template&id=d6d6d3ac&"
import script from "./GotoLeaveVoucher.vue?vue&type=script&lang=js&"
export * from "./GotoLeaveVoucher.vue?vue&type=script&lang=js&"
import style0 from "./GotoLeaveVoucher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports